angular.module('app').directive('apHeader', ['aprgettext', 'CurrentUserRepository', 'LogOffService', 'TransitionManager', 'SessionService', '$rootScope', '$log',
    function (gettext, CurrentUserRepository, LogOffService, TransitionManager, SessionService, $rootScope, $log) {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: '/app/partials/header/views/apHeader.html',
            scope: true,
            transclude: false,
            link: function (scope) {

                function onLoad() {
                    var activeUser = CurrentUserRepository.getActiveUser();

                    scope.apHeader = {
                        activeUserId : activeUser.id,
                        activeUserFullName: activeUser.fullName,
                        practiceName: ''
                    };
                   }

                var headerDataListener = $rootScope.$on('HeaderData:requested', function(event, requestor) {
                    var headerData = {
                        activeUserId: scope.apHeader.activeUserId,
                        activeUserFullName: scope.apHeader.activeUserFullName,
                        requestor : requestor
                    };
                    $rootScope.$broadcast('HeaderData:updated', headerData);
                });

                function toggleMobileNav() {
                    SessionService.setShowMobileNav(!SessionService.getShowMobileNav());
                }

                function signOff() {
                    $log.info('User has selected the Sign Out option from the header drop down menu.');

                    LogOffService.logoff().then(function () {
                        TransitionManager.transition({appRoute: 'login'});
                    });
                }

                onLoad();

                scope.$on('$destroy', function () {
                    headerDataListener();
                });

                scope.toggleMobileNav = toggleMobileNav;
                scope.signOff = signOff;
            }
        };
    }]);